export const stripBaseUrl = (url) => {
  return url?.split('/').slice(0, -1).join('/')
}

export const retrieveURLKey = (url, key) => {
  const [path, query] = url.split('?');
  const params = new URLSearchParams(query);
  const value = params.get(key);
  return value;
};

export const withHTTP = (url) => {
  return url?.startsWith('https://') || url?.startsWith('http://');
};

export const shortenNumber = (number) => {
  if (number >= 1_000_000_000) {
    return `${(number / 1_000_000_000).toFixed(1).replace(/\.0$/, '')}B`;
  }
  if (number >= 1_000_000) {
    return `${(number / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
  }
  if (number >= 1_000) {
    return `${(number / 1_000).toFixed(1).replace(/\.0$/, '')}k`;
  }
  return number.toString();
};

export const capitalizeFirstLetter = (string) => {
  if (typeof string !== 'string' || string.length === 0) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const retrieveIDFromUrl = (relativeUrl) => {
  const urlParams = new URLSearchParams(relativeUrl.split('?')[1]);
  const userParam = urlParams.get("user");

  if (userParam) {
    const parts = userParam.split('-');
    return parts[parts.length - 1];
  }

  return null;
};

export const toSlug = (string) => {
  return string?.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
};

export const retrieveLastDigitFromURL = (url) => {
  const match = url.match(/-(\d+)$/);
  return match ? match[1] : null;
};

export const snakeToSentence = (string) => {
  return string
    .replace(/_/g, " ")
    .replace(/\s+/g, " ")
    .trim();
};

export const kebabToSentence = (string) => {
  return string ? string.replace(/-/g, ' ') : '';
};

export function htmlToText(htmlContent = "") {
  if (typeof window === "undefined") return htmlContent; // SSR safety
  const doc = new DOMParser().parseFromString(htmlContent, "text/html");
  return doc.body.textContent || "";
}

/**
 * Converts a kebab-case string (e.g., "user-profile") to "User Profile".
 *
 * @param {string} string - The slug to format.
 * @returns {string} - Title-cased string.
 */
export const formatSlugToTitle = (string) => {
  // console.log(string, typeof str !== "string", !string.trim());
  if (!string || !string.trim()) return "";
  
  return string
    .trim()
    .replace(/[-_]+/g, " ")
    .replace(/\s+/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
